export default function calculateFees(total, installments, feeValue = 0.016) {

  return parseInt(total + (installments > 1 ? ((total * feeValue) * (installments - 1)) : 0), 10);


}
